import { render, staticRenderFns } from "./bfvideo.vue?vue&type=template&id=942d952a&scoped=true&"
import script from "./bfvideo.vue?vue&type=script&lang=js&"
export * from "./bfvideo.vue?vue&type=script&lang=js&"
import style0 from "./bfvideo.vue?vue&type=style&index=0&id=942d952a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942d952a",
  null
  
)

export default component.exports